/**
 * Since these async functions are not generators, using redux-saga and its utility functions inside
 * are difficult. So the functions in these files should only be used if you're in a context that does not have access
 * to redux. e.g. The Mention plugin for our editor.
 */

import { configurePuppyOptions, configureOptions, getApiResponse } from './base';
import type { GlobalRequestArguments, XhrRequestOptions } from './types';

/**
 * Calls puppy.
 *
 * This is the one you want if you don't have access to redux. <1% of cases, probably.
 */
export async function requestPuppyAsync(
  options: XhrRequestOptions,
  globalArguments: GlobalRequestArguments,
  papiBase: string = 'dashared'
): Promise<any> {
  options = configurePuppyOptions(options, globalArguments, papiBase);
  return getApiResponse(options);
}

/**
 * Same as requestPuppyAsync but for NAPI.
 */
export async function requestNapiAsync(
  options: XhrRequestOptions,
  globalArguments: GlobalRequestArguments
): Promise<any> {
  options = configureOptions(options, globalArguments);
  return getApiResponse(options);
}
